import { render } from "./PrivacyChecker.vue?vue&type=template&id=5686971e&scoped=true"
import script from "./PrivacyChecker.vue?vue&type=script&lang=js"
export * from "./PrivacyChecker.vue?vue&type=script&lang=js"

import "./PrivacyChecker.vue?vue&type=style&index=0&id=5686971e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5686971e"]])

export default __exports__